import { ComponentView } from "binder";
import { PictureCaptureViewModel } from "./pictureCapture-viewModel"
import CameraPhoto, { FACING_MODES, IMAGE_TYPES, downloadPhoto, _getDebugPlatformInfo } from 'jslib-html5-camera-photo';

export class PictureCaptureView extends ComponentView<PictureCaptureViewModel>{
    GetViewUniqueId(): string {
        return "V-AE6F7FA5-5462-4121-8056-DD4CBF58AA79"
    }
    loadHtml(): string {
        let element = require('./pictureCapture.html').default;
        let style = require('./pictureCapture.less');
        return element;
    }
    constructor() {
       super();
    }
    private _videoElement : HTMLVideoElement;
    private _camera : any;
    public set showFront(v: boolean) { this._showFront = v; } public get showFront(): boolean { return this._showFront;} private _showFront: boolean;
    public set image(v: string) { this._image = v; } public get image(): string { return this._image;} private _image: string;

    onRenderCompleted(){
        this._videoElement = this.firstlevelElement.querySelector('video');
        this.initialize();
        setTimeout(() => {
            this.checkForClose();
        }, 5000);
    }
    
    async checkForClose(){
        if(this._videoElement){
            if(this._videoElement.isConnected==false){
                try{
                    await this.stop();
                }catch{
                    setTimeout(() => {
                        this.checkForClose();
                    }, 5000);
                }
            }else{
                setTimeout(() => {
                    this.checkForClose();
                }, 5000);
            }
        }
    }

    async initialize(){

        this._camera = new CameraPhoto(this._videoElement);
        let facingMode = this.getFacingMode();
        await this._camera.startCamera(FACING_MODES[facingMode])

    }
    async stop(){
        await this._camera.stopCamera()
    }
    takeImage(){
        let sizeFactor = 1;
        let imageType = IMAGE_TYPES.PNG;
        let imageCompression = 1;
      
        let config = {
          sizeFactor,
          imageType,
          imageCompression
        };
      
        let dataUri = this._camera.getDataUri(config);
        this.image = dataUri.split(',')[1];
    }

    async switch(){
        await this.stop();
        this.showFront = !this.showFront;
        await this.initialize();;
    }

    getFacingMode(){
        if(this.showFront==false){
            return 'ENVIRONMENT';
        }else{
            return 'USER';
        }
    }
}
